import { IconWrapper } from '../runtime';
export default IconWrapper('mind-mapping-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0.5 3.75C0.5 1.67893 2.17893 0 4.25 0H20.75C22.8211 0 24.5 1.67893 24.5 3.75V20.25C24.5 22.3211 22.8211 24 20.75 24H4.25C2.17893 24 0.5 22.3211 0.5 20.25V3.75Z",
      "fill": 'url(#' + props.id + 'e88d983b' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M17 7.125H10.25L12.1705 5.2045C12.3815 4.99353 12.6676 4.875 12.966 4.875H18.5C18.9142 4.875 19.25 5.21079 19.25 5.625V10.125C19.25 10.5392 18.9142 10.875 18.5 10.875H14V8.625H17V7.125ZM10.25 10.875H6.5V13.125H10.25V10.875ZM5 8.625C4.58579 8.625 4.25 8.96079 4.25 9.375V14.625C4.25 15.0392 4.58579 15.375 5 15.375H11.75C12.1642 15.375 12.5 15.0392 12.5 14.625V9.375C12.5 8.96079 12.1642 8.625 11.75 8.625H5ZM10.3438 16.875H17V15.375H14V13.125H18.5C18.9142 13.125 19.25 13.4608 19.25 13.875V18.375C19.25 18.7892 18.9142 19.125 18.5 19.125H12.966C12.6676 19.125 12.3815 19.0065 12.1705 18.7955C11.5475 18.1725 10.8818 17.5756 10.3438 16.875Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'e88d983b',
      "x1": "0.5",
      "y1": "0",
      "x2": "24.5",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#00CFC8"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#00A78B"
    }
  })])])]);
});